import { CheckboxesInput } from "./classes/CheckboxesInput";
import { GroupLabel } from "./classes/GroupLabel";
import { LocationInput } from "./classes/LocationInput";
import { Store } from "./classes/Store";
import { getQueryFromState } from "./helpers/getQueryFromState";
import { initDataFromDocument } from "./helpers/initDataFromDocument/initDataFromDocument";
import { getLabelLocalite } from "./helpers/labels/getLabelLocalite";
import { getLabelTypeDeBien } from "./helpers/labels/getLabelTypeDeBien";
import { getLabelTypeViager } from "./helpers/labels/getLabelTypeViager";
import { startSearch } from "./helpers/startSearch";

/** INIT FUNCTION */

function init() {
  const store = new Store();
  const data = initDataFromDocument();

  // LABELS

  const labelTypeDeBien = new GroupLabel(
    document.getElementById("label-property-type")!,
    getLabelTypeDeBien
  );
  const labelTypeViager = new GroupLabel(
    document.getElementById("label-viager-type")!,
    getLabelTypeViager
  );
  const labelLocalite = new GroupLabel(
    document.getElementById("label-location")!,
    getLabelLocalite
  );

  // INPUTS

  new CheckboxesInput({
    store,
    data,
    name: "type-de-bien",
    label: labelTypeDeBien,
  });
  new CheckboxesInput({
    store,
    data,
    name: "type-viager",
    label: labelTypeViager,
  });
  new LocationInput({
    store,
    data,
    label: labelLocalite,
  });

  // SEARCH BUTTONS

  [...document.getElementsByClassName("start-search")].map((element) => {
    element.addEventListener(
      "click",
      () =>
        (window.location.href = `/achetez-en-viager${getQueryFromState(
          store.getState()
        )}`)
    );
  });
}

document.addEventListener("DOMContentLoaded", init);
